import { createSlice } from "@reduxjs/toolkit";
import {
    fetchPaymentManagement,
    fetchPaymentManagementByType,
    fetchPaymentManagementById,
    createPaymentManagement,
    updatePaymentManagement,
    deletePaymentManagement,
    fetchPaymentFollowUps,
    createPaymentFollowUp,
    updatePaymentFollowUp,
    deletePaymentFollowUp,
    exportPaymentManagementCSV,
    addProductsAndServices,
    // fetchProductsAndServicesById,
    updateProductsAndServices,
    // fetchProductsAndServicesByType,
    updateStatusInProductsAndServices,
    fetchProductsAndServicesByDropDown,
    fetchCategories,
    fetchSubcategories,
    fetchMakes,
    fetchModels,
    fetchPaymentHistory,
    addRecordPayment,
    removeRecordPayment,
    addFollowUp
} from "./thunk";

interface PaymentManagementState {
    paymentManagementList: any[];
    rowCount: number;
    loading: boolean;
    error: string | null;
    selectedPaymentManagement: any;
    followUps: any[];
    productsandservicesList: any[];
    selectedProductsAndServices: any;
    categories: any[];
    subcategories: any[];
    makes: any[];
    models: any[];
    paymentHistory: any[];
}

const initialState: PaymentManagementState = {
    paymentManagementList: [],
    rowCount: 0,
    loading: false,
    error: null,
    selectedPaymentManagement: null,
    followUps: [],
    productsandservicesList: [],
    selectedProductsAndServices: null,
    categories: [],
    subcategories: [],
    makes: [],
    models: [],
    paymentHistory: [],
};

const paymentManagementSlice = createSlice({
    name: "paymentmanagement",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Payment Management CRUD operations
            .addCase(fetchPaymentManagement.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaymentManagement.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentManagementList = action.payload.data;
                state.rowCount = action.payload.rowCount;
            })
            .addCase(fetchPaymentManagement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch payment management";
            })
            .addCase(fetchPaymentManagementByType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaymentManagementByType.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentManagementList = action.payload.data;
                state.rowCount = action.payload.rowCount;
            })
            .addCase(fetchPaymentManagementByType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch payment management by type";
            })
            .addCase(fetchPaymentManagementById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaymentManagementById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedPaymentManagement = action.payload;
            })
            .addCase(fetchPaymentManagementById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(createPaymentManagement.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.paymentManagementList = [action.payload, ...state.paymentManagementList];
            })
            .addCase(createPaymentManagement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to create payment management";
            })
            .addCase(updatePaymentManagement.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.paymentManagementList = state.paymentManagementList.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                );
            })
            .addCase(updatePaymentManagement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update payment management";
            })
            .addCase(deletePaymentManagement.fulfilled, (state, action) => {
                state.paymentManagementList = state.paymentManagementList.filter(
                    (item) => item.id !== action.payload
                );
            })
            .addCase(deletePaymentManagement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to delete payment management";
            })
            // Payment Follow-up operations
            .addCase(fetchPaymentFollowUps.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaymentFollowUps.fulfilled, (state, action) => {
                state.loading = false;
                state.followUps = action.payload;
            })
            .addCase(fetchPaymentFollowUps.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(createPaymentFollowUp.fulfilled, (state, action) => {
                state.followUps = [...state.followUps, action.payload];
            })
            .addCase(createPaymentFollowUp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to create payment follow-up";
            })
            .addCase(updatePaymentFollowUp.fulfilled, (state, action) => {
                state.followUps = state.followUps.map((followUp) =>
                    followUp.id === action.payload.id ? action.payload : followUp
                );
            })
            .addCase(updatePaymentFollowUp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update payment follow-up";
            })
            .addCase(deletePaymentFollowUp.fulfilled, (state, action) => {
                state.followUps = state.followUps.filter(
                    (followUp) => followUp.id !== action.payload
                );
            })
            .addCase(deletePaymentFollowUp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to delete payment follow-up";
            })
            // Legacy Products and Services (keeping for backward compatibility)
            .addCase(fetchProductsAndServicesByDropDown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductsAndServicesByDropDown.fulfilled, (state, action) => {
                console.log(action.payload, "line no 38 in action reduer")
                state.loading = false;
                state.productsandservicesList = action.payload.data;
                state.rowCount = action.payload.rowCount;
            })
            .addCase(fetchProductsAndServicesByDropDown.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch Products and Services";
            })

            .addCase(addProductsAndServices.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.productsandservicesList = state.productsandservicesList.map((productsAndServices) =>
                    productsAndServices.id === action.payload.id ? action.payload : productsAndServices
                );
            })
            .addCase(addProductsAndServices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update GP";
            })
            .addCase(updateProductsAndServices.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                state.productsandservicesList = state.productsandservicesList.map((productsAndServices) =>
                    productsAndServices.id === action.payload.id ? action.payload : productsAndServices
                );
            })
            .addCase(updateProductsAndServices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update GP";
            })
            .addCase(updateStatusInProductsAndServices.fulfilled, (state, action) => {
                if (!action.payload?.id) return;
                // state.productsandservicesList = state.productsAndServicesList.map((productsAndServices) =>
                //   productsAndServices.id === action.payload.id ? action.payload : productsAndServices
                // );
            })
            .addCase(updateStatusInProductsAndServices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to update status";
            })
            // Categories
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Subcategories
            .addCase(fetchSubcategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSubcategories.fulfilled, (state, action) => {
                state.loading = false;
                state.subcategories = action.payload;
            })
            .addCase(fetchSubcategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Makes
            .addCase(fetchMakes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMakes.fulfilled, (state, action) => {
                state.loading = false;
                state.makes = action.payload;
            })
            .addCase(fetchMakes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Models
            .addCase(fetchModels.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchModels.fulfilled, (state, action) => {
                state.loading = false;
                state.models = action.payload;
            })
            .addCase(fetchModels.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Payment History & Records
            .addCase(fetchPaymentHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
                state.loading = false;
                state.paymentHistory = action.payload;
            })
            .addCase(fetchPaymentHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            .addCase(addRecordPayment.fulfilled, (state, action) => {
                // history is refreshed via thunk call in component
            })
            .addCase(removeRecordPayment.fulfilled, (state, action) => {
                state.paymentHistory = state.paymentHistory.filter(
                    (record) => record.id !== action.payload
                );
            })
            .addCase(addFollowUp.fulfilled, (state, action) => {
                state.followUps = [action.payload, ...state.followUps];
            });
    },
});

export default paymentManagementSlice.reducer;
